import FingerprintJS from '@fingerprintjs/fingerprintjs';

let fpPromise = null;

function ensureFingerprintJS() {
  if (!fpPromise) {
    fpPromise = FingerprintJS.load();
  }
  return fpPromise;
}

export async function getVisitorId() {
  try {
    const fp = await ensureFingerprintJS();
    const result = await fp.get();
    return result.visitorId;
  } catch (error) {
    return 'unknown';
  }
}

export default {
  install(Vue) {
    Vue.prototype.$fingerprint = {
      getVisitorId
    };
  }
};
